import * as SelectStyle from "@omni/ui/components/Form/Select/select.style";
import { cn } from "@omni/utils/styles";
import { ComponentProps, useId } from "react";
import { GroupBase, default as ReactSelect } from "react-select";

type Props<
    Option = unknown,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
> = ComponentProps<typeof ReactSelect<Option, IsMulti, Group>> & {
    isValid?: boolean;
    isInvalid?: boolean;
};

export const Select = <
    Option = unknown,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
>({
    className,
    isValid = false,
    isInvalid = false,
    ...props
}: Props<Option, IsMulti, Group>) => {
    const id = useId();

    return (
        <ReactSelect<Option, IsMulti, Group>
            id={props.name || id}
            instanceId={props.name || id}
            {...props}
            classNames={{
                container: () =>
                    cn(
                        SelectStyle.container(),
                        props.classNames?.container,
                        className
                    ),
                control: ({ isFocused }) =>
                    cn(
                        SelectStyle.control({
                            isFocused: isFocused,
                            isInvalid: isInvalid,
                            isValid: isValid
                        }),
                        props.classNames?.control
                    ),

                valueContainer: () =>
                    cn(
                        SelectStyle.valueContainer(),
                        props.classNames?.valueContainer
                    ),
                clearIndicator: () =>
                    cn(
                        SelectStyle.clearIndicator(),
                        props.classNames?.clearIndicator
                    ),
                loadingIndicator: () =>
                    cn(
                        SelectStyle.loadingIndicator(),
                        props.classNames?.loadingIndicator
                    ),
                dropdownIndicator: () =>
                    cn(
                        SelectStyle.dropdownIndicator(),
                        props.classNames?.dropdownIndicator
                    ),
                indicatorSeparator: () =>
                    cn(
                        SelectStyle.indicatorSeparator(),
                        props.classNames?.indicatorSeparator
                    ),
                option: ({ isSelected, isFocused }) =>
                    cn(
                        SelectStyle.option({
                            isSelected: isSelected,
                            isFocused: isFocused
                        }),
                        props.classNames?.option
                    ),
                input: () => "input-select",
                menuList: () =>
                    cn(SelectStyle.menuList(), props.classNames?.menuList)
            }}
        />
    );
};
